import BaseService from '../../base/base_service';
import ObservableFactory from '../../utils/observable_factory';
import IObservableFactoryService from './observable_factory_service_interface';
import {TimeSpan} from "@sparkware/app-utils";
import {TimeIntervalName} from '../../../../common/utils/time-interval-names';
import Observable from '../../utils/observable';


export default class ObservableFactoryService extends BaseService implements IObservableFactoryService {
    static CLASS = 'ObservableFactoryService';

    _observableFactory: ObservableFactory = null;
    init(params) {
        super.init(params);
        this._observableFactory = ObservableFactory.create();
    }

    fromTimeout(timeout: TimeSpan | number, name?: TimeIntervalName) : Observable {
        return this._observableFactory.fromTimeout(timeout, name);
    }

    fromInterval(interval: TimeSpan | number, name?: TimeIntervalName) : Observable {
        return this._observableFactory.fromInterval(interval, name);
    }

    fromEvent(element: HTMLElement, eventName: string, options: any) : Observable {
        return this._observableFactory.fromEvent(element, eventName, options);
    }
}